import { Configuration } from "@api/configuration";
import { appConfig } from "../../app.config";

export const apiConfig = {
  basePath: appConfig.apiUrl,
} as Configuration;
